import { Injectable } from '@angular/core';
import { AuthApi } from './auth-api';
import { ConfigApi } from './config-api';
import { LoginApi } from './login-api';
import { OrderApi } from './order-api';
import { UserApi } from './user-api';
import { AppConfigService as AppConfig } from '../services/init/app-config.service';
import { PublisherService } from '../services/publisher.service';
import { IdmApi } from './idm-api';
import { ExpApi } from './exp-api';
import { CmsApi } from './cms-api';
import { ProductApi } from './product-api';
// import { ChatApi } from './chat-api';

@Injectable()
export class ParmedApiService {
  /******************Properties******************/
  Auth: AuthApi;
  Config: ConfigApi;
  Login: LoginApi;
  Order: OrderApi;
  User: UserApi;
  Idm: IdmApi;
  Exp: ExpApi;
  CMS: CmsApi;
  Product: ProductApi;
  // Chat: ChatApi;
  /******************Properties******************/

  constructor(private appConfig: AppConfig) {
    PublisherService.isConfigLoaded$.subscribe(loaded => {
      if (loaded) {
        this.Auth = new AuthApi(appConfig);
        this.Config = new ConfigApi(appConfig);
        this.Login = new LoginApi(appConfig);
        this.Order = new OrderApi(appConfig);
        this.User = new UserApi(appConfig);
        this.Idm = new IdmApi(appConfig);
        this.Exp = new ExpApi(appConfig);
        this.CMS = new CmsApi(appConfig);
        this.Product = new ProductApi(appConfig);
        // this.Chat = new ChatApi(appConfig);
      }
    });
  }
}
